import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FooterContainer } from "./FooterStyled";
import { FormattedMessage, useIntl } from 'react-intl';

import logo from './../../utils/images/name_logo_white.png';
import facebook from './../../utils/images/networks/facebook.png';
import instagram from './../../utils/images/networks/instagram.png';
import tiktok from './../../utils/images/networks/tiktok.png';
import twitter from './../../utils/images/networks/twitter.png';
import dropDown from './../../utils/images/arrow_dropdown.png';
import { getNetworksOfFluincr } from "../../api/networksApi";
import { LangContext } from "../../context/langContext";
import { getNewsletterEmailToVerified, postEmailToNewsletter } from "../../api/generalApi";
import { toUTCString } from "../../services/dateServices";
import Alert from "../../components/Alert/Alert";
import { getCountries } from "../../api/filtersApi";
import { FiltersContext } from "../../context/filtersContext";
import { getListCurrencies } from "../../api/exchangeApi";
import { CurrencyContext } from "../../context/currencyContext";
import { getLegalText } from "../../api/legalApi";
import { getStaticPages } from "../../api/adminApi";
import { contactEN, contactES, fluincrCaresEN, fluincrCaresES } from "../../utils/constants/constants";

export default function Footer() {

    const { locale, setLanguage, country, setCountry } = useContext(LangContext);
    const { countryFilter, setCountryFilter } = useContext(FiltersContext);
    const { currency, setCurrency, handlerCurrency } = useContext(CurrencyContext);

    const intl = useIntl();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [validEmail, setValidEmail] = useState(false);

    const [spanishFacebook, setSpanishFacebook] = useState('');
    const [englishFacebook, setEnglishFacebook] = useState('');

    const [spanishInstagram, setSpanishInstagram] = useState('');
    const [englishInstagram, setEnglishInstagram] = useState('');

    const [spanishTikTok, setSpanishTikTok] = useState('');
    const [englishTikTok, setEnglishTikTok] = useState('');

    const [spanishTwitter, setSpanishTwitter] = useState('');
    const [englishTwitter, setEnglishTwitter] = useState('');

    const [showAlertNewsLetter, setShowAlertNewsLetter] = useState(false);
    const [showAlertNewsLetterFail, setShowAlertNewsLetterFail] = useState(false);

    const [countriesOptions, setCountriesOptions] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    //const [selectedCurrency, setSelectedCurrency] = useState("COP - Colombian Peso");
    const [selectedCurrency, setSelectedCurrency] = useState("");

    const [spanishLegalTextList, setSpanishLegalTextList] = useState([]);
    const [englishLegalTextList, setEnglishLegalTextList] = useState([]);

    const [spanishStaticPagesList, setSpanishStaticPagesList] = useState([]);
    const [englishStaticPagesList, setEnglishStaticPagesList] = useState([]);

    const [showAlertInvalidEmail, setShowAlertInvalidEmail] = useState(false);

    useEffect(() => {
        getNetworksOfFluincr().then((response) => {
            response.map((networks) => {

                setSpanishFacebook(networks.socialnetwork.español.link_facebook);
                setSpanishInstagram(networks.socialnetwork.español.link_instagram);
                setSpanishTikTok(networks.socialnetwork.español.link_tiktok);
                setSpanishTwitter(networks.socialnetwork.español.link_twitter);

                setEnglishFacebook(networks.socialnetwork.ingles.link_facebook);
                setEnglishInstagram(networks.socialnetwork.ingles.link_instagram);
                setEnglishTikTok(networks.socialnetwork.ingles.link_tiktok);
                setEnglishTwitter(networks.socialnetwork.ingles.link_twitter);

            })
        })

        getCountries().then((response) => {
            setCountriesOptions(response);
        })

        getListCurrencies().then((response) => {
            setCurrencies(response);
        })

        getLegalText().then((response) => {
            const English = response.filter((legal) => legal.language === 'ENGLISH');
            const Spanish = response.filter((legal) => legal.language === 'SPANISH');
            setSpanishLegalTextList(Spanish);
            setEnglishLegalTextList(English);
        })

        getStaticPages().then((response) => {
            const English = response.filter((legal) => legal.language === 'ENGLISH');
            const Spanish = response.filter((legal) => legal.language === 'SPANISH');
            setSpanishStaticPagesList(Spanish);
            setEnglishStaticPagesList(English);
        })

    }, [])

    const [showCountriesOptions, setShowCountriesOptions] = useState(false);

    const [showLenguagesOptions, setShowLenguagesOptions] = useState(false);
    const [selectdLenguage, setSelectedLenguage] = useState(<FormattedMessage id="footer_lenguage_1" defaultMessage="Español" />);

    const [showCurrencyOptions, setShowCurrencyOptions] = useState(false);
    /* const [selectdCurrency, setSelectedCurrency] = useState(<FormattedMessage id="footer_currency_1" defaultMessage="COP- Colombian Peso" />); */


    const [showDataPolicy, setShowDataPolicy] = useState(false);

    const lenguages = [<FormattedMessage id="footer_lenguage_1" defaultMessage="Español" />, <FormattedMessage id="footer_lenguage_2" defaultMessage="Ingles" />];

    /* const currencies = [<FormattedMessage id="footer_currency_1" defaultMessage="Peso col - COP" />, <FormattedMessage id="footer_currency_2" defaultMessage="Dólar can - CAD" />, <FormattedMessage id="footer_currency_3" defaultMessage="Dólar us -USD" />]; */


    useEffect(() => {
        const expRegEmail = new RegExp('[a-z0-9]+@[a-z]+[.][a-z]{2,3}');
        if (expRegEmail.test(email)) {
            setValidEmail(true);
        } else {
            setValidEmail(false);
        }
    }, [email])

    const sendEmail = (e) => {
        e.preventDefault();
        if (validEmail) {
            getNewsletterEmailToVerified({ email }).then((response) => {
                if (response.length > 0) {
                    setShowAlertNewsLetterFail(true);
                } else {
                    postEmailToNewsletter({
                        body:
                        {
                            deleted: 0,
                            email: email,
                            creation: toUTCString(new Date())
                        }
                    }).then((response) => {
                        if (response.status === 201) {
                            setShowAlertNewsLetter(true);
                        }
                    })
                }
            })
        } else {
            setShowAlertInvalidEmail(true)
        }
    }

    useEffect(() => {

        if (locale === 'es-CO') {
            setSelectedLenguage(<FormattedMessage id="footer_lenguage_1" defaultMessage="Español" />)
        } else {
            setSelectedLenguage(<FormattedMessage id="footer_lenguage_2" defaultMessage="Inglés" />)
        }

    }, [locale])

    const select1Ref = useRef(null);
    const select2Ref = useRef(null);
    const select3Ref = useRef(null);

    useEffect(() => {

        function handleClickOutside(event) {
            if (select1Ref.current && !select1Ref.current.contains(event.target)) {
                setShowLenguagesOptions(false);
            }
            if (select2Ref.current && !select2Ref.current.contains(event.target)) {
                setShowCurrencyOptions(false);
            }
            if (select3Ref.current && !select3Ref.current.contains(event.target)) {
                setShowCountriesOptions(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [select1Ref, select2Ref, select3Ref])

    const handlerCountryFilter = (country) => {
        const auxCountryFilter = [...countryFilter];
        if (auxCountryFilter.includes(country)) {
            const newCountry = auxCountryFilter.filter(count => count !== country);
            setCountryFilter(newCountry);
            navigate('/influencers');
        } else {
            auxCountryFilter.push(country);
            setCountryFilter(auxCountryFilter);
            navigate('/influencers');
        }
    }

    return (
        <FooterContainer>
            <div className="top">
                <div className="subscribe">
                    <img src={logo} alt="logo" className="logo" />
                    <p>
                        <FormattedMessage id="footer_text" defaultMessage="Compra colaboraciones con influencers profesionales de manera eficiente y segura" />
                    </p>
                    <form action="submit" onSubmit={sendEmail}>
                        <input type="text" value={email} placeholder={intl.formatMessage({ id: "footer_input" })} onChange={(e) => {
                            setEmail(e.target.value)
                        }} />
                        <button>
                            <FormattedMessage id="footer_button _text" defaultMessage="Suscribirme" />
                        </button>
                    </form>
                </div>
                <div className="linksContainer">
                    <div className="links">
                        <h3 className="title">
                            <FormattedMessage id="footer_links_1" defaultMessage="Navegar por Fluincr" />
                        </h3>
                        <div className="list">
                            <p><Link to={"/"}><FormattedMessage id="footer_links_1_text_1" defaultMessage="Home" /></Link></p>
                            <p><Link to={"/signup"}><FormattedMessage id="footer_links_1_text_2" defaultMessage="Regístrate" /></Link></p>
                            <p><Link to={"/signin"}><FormattedMessage id="footer_links_1_text_3" defaultMessage="Inicia sesión" /></Link></p>
                            {/*  <p><Link to={"#"}><FormattedMessage id="footer_links_1_text_4" defaultMessage="Favoritos" /></Link></p> */}
                        </div>
                    </div>
                    <div className="links">
                        <h3 className="title">
                            <FormattedMessage id="footer_links_2" defaultMessage="General" />
                        </h3>
                        <div className="list">
                            {/* <p><Link to={"#"}><FormattedMessage id="footer_links_2_text_1" defaultMessage="Acerca de" /></Link></p> */}
                            <p><a target="_blank" rel="noreferrer" href={(locale === 'es-CO') ? fluincrCaresES : fluincrCaresEN}><FormattedMessage id="footer_links_2_text_2" defaultMessage="Fluincr Cares (Ayuda)" /></a></p>

                            <p><a target="_blank" rel="noreferrer" href={(locale === 'es-CO') ? contactES : contactEN}><FormattedMessage id="footer_links_2_text_3" defaultMessage="Contacto" /></a></p>

                            {(locale === 'es-CO') ? (spanishStaticPagesList.map((page) => {
                                return (
                                    <p>
                                        <Link to={`/static/${page.path}`}>{page.title}</Link>
                                    </p>
                                )
                            })) : (englishStaticPagesList.map((page) => {
                                return (
                                    <p>
                                        <Link to={`/static/${page.path}`}>{page.title}</Link>
                                    </p>
                                )

                            }))}
                            {/* <p><Link to={"#"}><FormattedMessage id="footer_links_2_text_4" defaultMessage="Venta de publicidad" /></Link></p> */}
                        </div>
                    </div>
                    <div className="links">
                        <h3 className="title">
                            <FormattedMessage id="footer_links_3" defaultMessage="Legal" />
                        </h3>
                        <div className="list">
                            {(locale === 'es-CO') ? (spanishLegalTextList.map((legal) => {
                                return (
                                    <p>
                                        <Link to={`/legal/${legal.path}`}>{legal.title}</Link>
                                    </p>
                                )

                            })) : (englishLegalTextList.map((legal) => {
                                return (
                                    <p>
                                        <Link to={`/legal/${legal.path}`}>{legal.title}</Link>
                                    </p>
                                )

                            }))}
                            {/* <p>
                                <Link to={"/terms"}><FormattedMessage id="footer_links_3_text_1" defaultMessage="Términos y condiciones del servicio" /></Link>
                            </p>

                            <p>
                                <Link to={"/policy"}>
                                    <FormattedMessage id="footer_links_3_text_2" defaultMessage="Politica de privacidad" />
                                </Link>
                            </p>

                            <p>
                                <Link to={"/guidelines"}><FormattedMessage id="footer_links_3_text_3" defaultMessage="Directrices de la Comunidad" /></Link>
                            </p> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom">
                <div className="functionalityContainer">

                    <div className="networks">
                        <a href={(locale === 'es-CO') ? spanishFacebook : englishFacebook}>
                            <img src={facebook} alt="facebook" />
                        </a>
                        <a href={(locale === 'es-CO') ? spanishInstagram : englishInstagram}>
                            <img src={instagram} alt="instagram" />
                        </a>
                        <a href={(locale === 'es-CO') ? spanishTikTok : englishTikTok}>
                            <img src={tiktok} alt="linkedin" className="tiktok" />
                        </a>
                        <a href={(locale === 'es-CO') ? spanishTwitter : englishTwitter}>
                            <img src={twitter} alt="twitter" />
                        </a>
                    </div>

                    <form action="submit">

                        <div className="selectBox" ref={select1Ref}>
                            <div className="select" id="select" onClick={() => setShowLenguagesOptions(!showLenguagesOptions)}>
                                <div className="selected" >
                                    <p className="country">{selectdLenguage}</p>
                                </div>
                                <img src={dropDown} alt="dropdown" className="dropdown" />
                            </div>
                            {
                                (showLenguagesOptions) && (
                                    <div className="options" id="options">
                                        {(lenguages.map((lenguage) => (
                                            <div className="option" key={lenguage} onClick={() => {
                                                setSelectedLenguage(lenguage);
                                                setShowLenguagesOptions(!showLenguagesOptions)
                                                if (lenguage.props.defaultMessage === 'Español') {
                                                    setLanguage('Spanish');
                                                    setCountry('Spanish');
                                                } else {
                                                    setLanguage('English');
                                                    setCountry('English');
                                                }
                                            }}
                                            >
                                                <p className="country">{lenguage}</p>
                                            </div>
                                        )))}
                                    </div>
                                )
                            }
                        </div>

                        <div className="selectBox" ref={select2Ref}>
                            <div className="select" id="select" onClick={() => setShowCurrencyOptions(!showCurrencyOptions)}>
                                <div className="selected" >
                                    {/* <p className="country">{selectedCurrency}</p> */}
                                    <p className="country">{currency?.symbol} - {currency?.name}</p>

                                </div>
                                <img src={dropDown} alt="dropdown" className="dropdown" />
                            </div>
                            {
                                (showCurrencyOptions) && (
                                    <div className="options" id="options">
                                        {(currencies.map((currency) => {
                                            if (currency.usedSymbol === true) {
                                                return (
                                                    <div className="option" key={currency} onClick={() => {
                                                        setSelectedCurrency(`${currency.symbol} - ${currency.name}`)
                                                        setShowCurrencyOptions(!showCurrencyOptions)
                                                        handlerCurrency(currency)
                                                    }}>
                                                        <p className="country">{currency.symbol} - {currency.name}</p>
                                                    </div>
                                                )
                                            }
                                        }


                                        ))}
                                    </div>
                                )
                            }

                        </div>
                        {/* <div className="selectBox" ref={select3Ref}>
                            <div className="select" id="select" onClick={() => setShowCountriesOptions(!showCountriesOptions)}>
                                <div className="selected" >
                                    <img src={selectedCountry.image} alt={selectedCountry.name} className="flag" />
                                    <p className="country">{selectedCountry.name}</p>
                                </div>
                                <img src={dropDown} alt="dropdown" className="dropdown" />
                            </div>
                            {
                                (showCountriesOptions) && (
                                    <div className="options" id="options">

                                        {(countriesOptions.map((country) => (
                                            <div className="option" key={country.id} onClick={() => {
                                                setSelectedCountry(country)
                                                setShowCountriesOptions(!showCountriesOptions)
                                                handlerCountryFilter(country.id)
                                            }}>
                                                <img src={country.image} alt='country flag' className="flag" />

                                                <p className="country">{(locale === 'es-CO') ? (country.nombre) : (country.name)}</p>
                                            </div>
                                        )))}
                                    </div>
                                )
                            }
                        </div> */}
                    </form>
                </div>

                <p className="copyright">Copyright © 2023 Fluincr</p>

            </div>

            {(showAlertNewsLetter) && (<Alert
                title={<FormattedMessage id="alert_forward_title" defaultMessage="¡Exitoso!" />}
                text={<FormattedMessage id="alert_newsletter_text_1" defaultMessage="El correo ha sido registrado" />}
                setShowAlert={setShowAlertNewsLetter}
            />)}

            {(showAlertNewsLetterFail) && (<Alert
                title={<FormattedMessage id="alert_forward_title_2" defaultMessage="¡Error!" />}
                text={<FormattedMessage id="alert_newsletter_text_2" defaultMessage="Este correo ya se encuentra registrado" />}
                setShowAlert={setShowAlertNewsLetterFail}
            />)}

            {(showAlertInvalidEmail) && (<Alert
                title={<FormattedMessage id="alert_forward_title_2" defaultMessage="¡Error!" />}
                text={<FormattedMessage id="alert_newsletter_text_3" defaultMessage="Ha ingresado una cuenta de correo invalido" />}
                setShowAlert={setShowAlertInvalidEmail}
            />)}

        </FooterContainer>
    )
}